<template>
  <div v-loading="isLoading">
    <h1 class="tw-mb-3">
      {{ $t('dashboard.messaging_metrics.title') }}
    </h1>
    <MessagingMetrics v-if="!isMessagingMetricsByUserLoading" />
    <h1 class="tw-mt-6 tw-mb-3">
      {{ $t('dashboard.permit_status_metrics.title') }}
    </h1>
    <PermitStatusesMetricsTable v-if="!isPermitStatusMetricsLoading" />
    <h1 class="tw-mt-6 tw-mb-3">
      {{ $t('dashboard.permit_action_date_metrics.title') }}
    </h1>
    <PermitActionDateMetricsTable v-if="!isPermitActionDatesMetricsLoading" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';
import MessagingMetrics from '@/views/admin/dashboard/components/MessagingMetrics.vue';
import PermitStatusesMetricsTable from '@/views/admin/dashboard/components/PermitStatusesMetricsTable.vue';
import PermitActionDateMetricsTable from '@/views/admin/dashboard/components/PermitActionDateMetricsTable.vue';
import { BarController, BarElement, CategoryScale, Chart, Legend, LinearScale, Tooltip } from 'chart.js';

Chart.register(LinearScale, CategoryScale, BarElement, BarController, Legend, Tooltip);

export default defineComponent({
  name: 'Dashboard',
  components: { PermitActionDateMetricsTable, PermitStatusesMetricsTable, MessagingMetrics },
  computed: {
    ...mapState({
      isMessagingMetricsByUserLoading: (state) => state.v2.admin.dashboard.isMessagingMetricsByUserLoading,
      isPermitStatusMetricsLoading: (state) => state.v2.admin.dashboard.isPermitStatusMetricsByUserLoading,
      isPermitActionDatesMetricsLoading: (state) => state.v2.admin.dashboard.isPermitActionDatesMetricsByUserLoading,
      messagingMetricsFilters: (state) => state.v2.admin.dashboard.messagingMetricsFilters,
      permitStatusMetricsFilters: (state) => state.v2.admin.dashboard.permitStatusMetricsFilters,
      permitActionDatesMetricsFilters: (state) => state.v2.admin.dashboard.permitActionDatesMetricsFilters,
    }),
    ...mapGetters({
      internalUsersAreEmpty: 'v2/admin/cms/internal/users/selectOptionsAreEmpty',
      clientCompaniesAreEmpty: 'v2/admin/cms/clients/companies/selectOptionsAreEmpty',
    }),
    isLoading() {
      return this.isMessagingMetricsByUserLoading || this.isPermitStatusMetricsLoading || this.isPermitActionDatesMetricsLoading;
    },
  },
  watch: {
    messagingMetricsFilters: {
      handler() {
        this.$store.dispatch('v2/admin/dashboard/loadMessagingUsersMetrics');
        this.$store.dispatch('v2/admin/dashboard/loadMessagingAverageMetrics');
      },
      deep: true,
    },
    permitStatusMetricsFilters: {
      handler() {
        this.$store.dispatch('v2/admin/dashboard/loadPermitStatusMetrics');
        this.$store.dispatch('v2/admin/dashboard/loadPermitStatusAverageMetrics');
      },
      deep: true,
    },
    permitActionDatesMetricsFilters: {
      handler() {
        this.$store.dispatch('v2/admin/dashboard/loadPermitActionDatesMetrics');
        this.$store.dispatch('v2/admin/dashboard/loadPermitActionDateAverageMetrics');
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.internalUsersAreEmpty) {
      await this.$store.dispatch('v2/admin/cms/internal/users/loadAllUsers');
    }
    if (this.clientCompaniesAreEmpty) {
      this.$store.dispatch('v2/admin/cms/clients/companies/loadAllCompanies');
    }
    this.$store.dispatch('v2/admin/dashboard/loadMessagingUsersMetrics');
    this.$store.dispatch('v2/admin/dashboard/loadMessagingAverageMetrics');
    this.$store.dispatch('v2/admin/dashboard/loadPermitStatusMetrics');
    this.$store.dispatch('v2/admin/dashboard/loadPermitStatusAverageMetrics');
    this.$store.dispatch('v2/admin/dashboard/loadPermitActionDatesMetrics');
    this.$store.dispatch('v2/admin/dashboard/loadPermitActionDateAverageMetrics');
  },
});
</script>
